export default __webpack_public_path__ + "static/media/close-light-gray.c47c3262.svg";